import { useState } from 'react';
import { FlaskConical, Maximize2, Mountain } from 'lucide-react';
import { AquaLabView } from './AquaLabView';
import { LabValley } from './LabValley';
import { vt } from '../lib/valleyText';

// AquaFlow tab "profile lab": short description, the lab itself opens full size
export function AquaLab(props) {
  const { t } = props, [open, setOpen] = useState(false), [vOpen, setVOpen] = useState(false);
  return (
    <div className="aq-lab" data-testid="lab-panel">
      <b><FlaskConical size={15} /> {t.labTitle}</b>
      <small className="muted">{t.labSide}</small>
      <small>{t.labSteps}</small>
      <button className="btn btn-accent aq-run" data-testid="lab-open" onClick={() => setOpen(true)}><Maximize2 size={16} /> {t.labOpen}</button>
      <button className="btn btn-accent aq-run" data-testid="valley-open" onClick={() => setVOpen(true)}><Mountain size={16} /> {vt().open}</button>
      {open && <AquaLabView {...props} onClose={() => setOpen(false)} />}
      {vOpen && <LabValley project={props.project} onClose={() => setVOpen(false)} />}
    </div>
  );
}
